import { createFileRoute, redirect } from "@tanstack/react-router"
import { isEqual, pick } from "lodash"

const PERSISTED_FILTER_KEYS = ["tags", "orgs", "sort", "types"] as const

export const Route = createFileRoute("/dashboard/")({
  beforeLoad: ({ search }) => {
    let storageFilters = JSON.parse(
      localStorage.getItem("filters") || "{}",
    ) as typeof search

    if ("search" in storageFilters) {
      const { search: _removed, ...rest } = storageFilters
      storageFilters = rest
      localStorage.setItem("filters", JSON.stringify(rest))
    }

    const urlFilters = pick(search, PERSISTED_FILTER_KEYS)
    const storedFilters = pick(storageFilters, PERSISTED_FILTER_KEYS)

    if (isEqual(storedFilters, urlFilters)) return

    throw redirect({
      to: ".",
      search: { ...search, ...storedFilters },
    })
  },
})
